import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { query, where, getDocs, collection } from "firebase/firestore";
//import { db } from "../firebase";  
import Cookies from 'js-cookie';
//page links   
import './footer.css';
import GooglePlayIcon from '../assets/android-app_v1.png';
import Appstore from '../assets/ios-app_v1.png';
import { BsYoutube } from 'react-icons/bs';
import Save_inquary from './save_inquary';
export default function Footers() {
  const navigate = useNavigate();
  const location = useLocation();
  const [Jobtasks, setJobtasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [mobileapp, setMobileapp] = useState(false);

  const [rowCounts, setRowCounts] = useState({
    users: 0,
    postdata: 0,
    companys: 0,
    total: 0
  });
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setMobileapp(true);
      } else {
        setMobileapp(false);
      }
    };
    // Run once on mount
    handleResize();
    // Attach resize listener
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  let footers = true;
  // let page = location.pathname;
  // if (page === "/" || page === "/about" || page === "/support" || page === "/terms-and-conditions" || page === "/privacy-policy" || page === "/refund-policy") {
  //   footers = true;
  // } else {
  //   footers = false;
  // }
  return (
    <div className="footer-body ">
      {footers === true ?
        <div className='items-back'>
          {mobileapp === false && (

            <div className="tearms_body">
              <div className="container_size_info">
                <table>
                  <tr  >
                    <td width={190}> <a href='https://aooz.in' className='bold cursor'>Aooz.in</a> - {new Date().getFullYear()} All rights reserved. </td>
                    <td >
                      <a className="tab-link text-h3 m-1" title='Terms and Conditions' href='/terms-and-conditions'>Terms and Conditions</a> |
                             <a className="tab-link text-h3 m-1" title='privacy policy' href='/privacy-policy'>Privacy policy</a>
                       | <a className="tab-link text-h3 m-1" title='sitemap' href='/sitemap'>Sitemap</a>
   | <a className="tab-link text-h3 m-1" title='support' href='/support'>Support</a>
                    </td>
                    <td width={140} className='text-r '> <a className='text-h3'>Update 10 august 2026</a></td>
                  </tr>
                </table>

              </div>
            </div>
          )}
        </div>
        : ""}
    </div>

  );
}
